import Sugar from 'sugar';
globalThis.Sugar = Sugar;
